// src/app/orders/admin-order-status/admin-order-status.component.ts
import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { OrderTracking } from '../../models/tracking.model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-admin-order-status',
  templateUrl: './admin-order-status.component.html',
  styleUrls: ['./admin-order-status.component.scss']
})
export class AdminOrderStatusComponent implements OnInit {
  orders: any[] = [];
  loading = false;
  selectedOrder?: OrderTracking;
  updating = false;

  statuses = ['Pending', 'Confirmed', 'Packed', 'Shipped', 'Delivered', 'Cancelled'];
    status: any;
    description: any;
    toast: any;

  constructor(private orderService: OrderService) { }

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders() {
    this.loading = true;
    this.orderService.getAllOrders().pipe(finalize(() => this.loading = false)).subscribe({
      next: (res) => this.orders = res,
      error: (err) => console.error(err)
    });
  }

  openTracking(orderId: any) {
    this.orderService.getOrderTracking(orderId).subscribe({
      next: (res) => this.selectedOrder = res,
      error: (err) => console.error(err)
    });
  }

  updateStatus(order: any, newStatus: string, description: string) {
    if (!confirm(`Change status of #${order.id} to ${newStatus}?`)) return;
    this.updating = true;
    this.orderService.updateOrderStatus(order.id,
      {
        status: newStatus,
        description: description
      }).pipe(finalize(() => this.updating = false)).subscribe({
      next: () => {
        order.currentStatus = newStatus;
        this.toast.show("Order status updated", "success");
      },
      error: (err) => {
        this.toast.show("Failed to update status", "error");
      }
    });
  }
}
